import { render } from "./EmailOTP.vue?vue&type=template&id=e4fd75e8"
import script from "./EmailOTP.vue?vue&type=script&lang=js"
export * from "./EmailOTP.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__